import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, FormGroup, Input, Label, Row, Form, UncontrolledTooltip } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import i18n from '../../../i18next';
import MaterialIcon from 'material-icons-react';
import moment from 'moment';
import { downloadCustomersData, getCustomersInfo } from '../../../actions';
import SearchButton from '../../common/SearchButton';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE, MENUU_MASTER_ADMIN } from '../../../utils/Constants';
import Pagination from 'react-js-pagination';
import CommonMessage  from '../customerInsightScreen/CommonMessage';

class CustomersContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            searchQuery: { 
                name: '',
                phone: '',
                status: '',
                email: '',
                isVip: false
            },
            currentPageNumber: 0,
            
        }
        this.changeState = this.changeState.bind(this);
        this.search = this.search.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.getCustomersInfo(this.state.searchQuery, this.state.currentPageNumber, id);
    }

    clearState() {
        this.setState({
            startDate: null,
            endDate: null
        }, () => {
            document.getElementById("startDate").value = '';
            document.getElementById("endDate").value = '';
        })
    }

    search() {
        const { id } = this.props.match.params;
        this.props.getCustomersInfo(this.state.searchQuery, 0, id);
    }

    clearSearch() {
        const { id } = this.props.match.params;
        this.setState({
            searchQuery: { 
                name: '',
                phone: '',
                status: '',
                email: '',
                isVip: false
            },
            currentPageNumber: 0
        },
        () => this.props.getCustomersInfo(this.state.searchQuery, this.state.currentPageNumber, id)
        )
    }

    handlePageChange(pageNumber) {
        const { id } = this.props.match.params;
        this.setState({
            currentPageNumber: (pageNumber - 1)
        },
        () => this.props.getCustomersInfo(this.state.searchQuery, this.state.currentPageNumber, id)
        )
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { customersInfo } = this.props.customersInfo;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={customersInfo.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={customersInfo.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    downloadCustomers(restaurantId) {

        this.props.downloadCustomersData(restaurantId, this.state.startDate, this.state.endDate, () => {
            this.clearState()
        })
    }

    changeState = ({ target }) => {
        let targetValue = target.value;

        if (target.type === 'date') {
            targetValue = target.value.split(/\D/);
            targetValue = new Date(targetValue[0], --targetValue[1], targetValue[2]);
            targetValue = moment(targetValue).format("DD-MM-YYYY")
            
            this.setState({
                ...this.state,
                [target.name]: targetValue
            })
        }

        if(target.name === 'isVip') {
            this.setState({
                searchQuery: {
                    ...this.state.searchQuery,
                    isVip: !this.state.searchQuery.isVip
                }
            })
        } else {
            this.setState({
                searchQuery: {
                    ...this.state.searchQuery,
                    [target.name]: target.value
                },
            });
        }
    }
    
    renderCustomerStatus(currentStatus) {
        switch(currentStatus) {
            case 0:
                return i18n.t('screens:customerInsightScreen.regular');
            case 1:
                return i18n.t('screens:customerInsightScreen.infrequent');
            case 2: 
                return i18n.t('screens:customerInsightScreen.atRisk');
            case 3: 
                return i18n.t('screens:customerInsightScreen.lost');
            default :
                return null;
        }
    }

    renderCustomerStatusIndicator(i, statusMovement) {
            if(statusMovement === 'up') {
                return (
                    <span id={`positiveIndicator${i}`}>
                        <MaterialIcon icon='north' color="green" size={17}/>
                        {/* <UncontrolledTooltip placement="top" target={`positiveIndicator${index}`} >
                                    {`${totalMovementPercent}%`}
                        </UncontrolledTooltip> */}
                    </span>
                )             
            } else if(statusMovement === 'down') {
                return (
                    <span id={`negativeIndicator${i}`}>
                        <MaterialIcon icon='south' color="red" size={17}/>
                        {/* <UncontrolledTooltip placement="top" target={`negativeIndicator${index}`} >
                                    {`${totalMovementPercent}%`}
                        </UncontrolledTooltip> */}
                    </span>
                )
            } else if(statusMovement === null) {
                return null;
            }
    }

    renderCustomerVip(isVip) {
        if(isVip) {
            return i18n.t('screens:marketingAutomationScreen.vipCustomers')
        } else {
            return i18n.t('screens:marketingAutomationScreen.noVipCustomers')
        }
    }

    renderCustomersStatusDropdown = () => {
        const { inputFieldsStyle, inputFieldsColStyle } = styles;
        return (
            <Col style={inputFieldsColStyle} >
                <Input
                    type="select"
                    name="status"
                    id="status"
                    placeholder={i18n.t('screens:customersScreen.selectCustStatus')}
                    value={this.state.searchQuery.status}
                    style={inputFieldsStyle}
                    onChange={this.changeState}>
                    <option value=''>{i18n.t('screens:customersScreen.selectCustStatus')}</option>
                    <option value='Regular'>{i18n.t('screens:customerInsightScreen.regular')}</option>
                    <option value='Infrequent'>{i18n.t('screens:customerInsightScreen.infrequent')}</option>
                    <option value='At Risk'>{i18n.t('screens:customerInsightScreen.atRisk')}</option>
                    <option value='Lost'>{i18n.t('screens:customerInsightScreen.lost')}</option>
                </Input>
            </ Col>
        );
    }

    renderCustomerInfoTable() {
        const { headerContainer } = styles;
        const { customersInfo } = this.props.customersInfo;

        return (
            <Col >
                <Row style={headerContainer}>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerName')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerPhone')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerEmail')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerStatus')}</Col>
                    <Col xs={2}>{i18n.t('screens:customersScreen.statusMovement')}</Col>
                    <Col xs={2}>
                        {i18n.t('screens:marketingAutomationScreen.vipStatus')}
                        <span style={{ marginLeft: '4px', position: 'absolute', cursor: 'pointer'}} id='vipStatusInfo'>
                            <MaterialIcon icon='info' color="#0288D1" size={15}/>
                        </span>
                        <UncontrolledTooltip placement="top" target={'vipStatusInfo'} >
								{i18n.t('screens:customersScreen.vipStatusInfo')}
						</UncontrolledTooltip>
                    </Col>
                </Row>
                {
                    customersInfo && customersInfo.content && customersInfo.content.length > 0 ?
                        this.renderTableRows() :
                        <Col style={{ width: '100%', padding: '15px 15px 0', borderBottom: '1px solid #dee2e6' }}>
                            <p style={{ fontSize: '14px' }}>{i18n.t('screens:centralOrdersLog.noResults')}</p>
                        </Col>
                }
                <Col style={{ paddingRight: '0px' }}>{this.renderPagination()}</Col>
            </Col>
        );
    }

    renderTableRows() {
        const { headerContainer, selectOrderStyle } = styles;
        const { customersInfo } = this.props.customersInfo;
        const { id } = this.props.match.params;

        return customersInfo.content.map((customer, i) => {
            
            return (
                <Row style={{...headerContainer, backgroundColor: 'fff', borderBottom: '1px solid rgb(222, 226, 230)'}}>
                    <Col xs={2}>
                        <NavLink tag={Link} style={selectOrderStyle} to={`/restaurant/${id}/customer-insight/${customer.customerId}`}>
                            {customer.name}
                        </NavLink>
                    </Col>
                    <Col xs={2}>{customer.formattedPhone}</Col>
                    <Col xs={2}>{customer.email}</Col>
                    <Col xs={2}>{this.renderCustomerStatus(customer.currentStatus)}</Col>
                    <Col xs={2}>{this.renderCustomerStatusIndicator(i, customer.statusMovement)}</Col>
                    <Col xs={2}>{this.renderCustomerVip(customer.vip)}</Col>
                </Row>
            )
        }) 
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderSearchFields() {
        const {
            name,
            phone,
            email,
            isVip
        } = this.state.searchQuery

        const { inputFieldsColStyle, inputFieldsStyle } = styles;

        return (
            <Row xs="auto" sm={12} style={{ display: 'flex', paddingRight: 0 }}>
                <Form id="advanceSearchForm" onKeyUp={this.onKeyUp}>
                    <Row style={{paddingLeft: '30px'}}>
                        <Col style={{...inputFieldsColStyle, display: 'flex', flexDirection: 'column'}}>
                            <Input 
                                type="text" 
                                name="name" 
                                id="name" 
                                placeholder={i18n.t('screens:orderHistoryScreen.customerName')} 
                                value={name} 
                                onChange={this.changeState}
                                style={inputFieldsStyle} 
                            />
                            <div style={{marginTop: '10px', paddingLeft: '12px'}}>
                                <Label for='isVip' style={{ marginBottom: 0 }}>{i18n.t('screens:marketingAutomationScreen.vipStatus')}</Label>
                                <Input 
                                    type='checkbox' 
                                    id='isVip' 
                                    name='isVip' 
                                    onChange={this.changeState}
                                    checked={isVip}
                                    style={{left: '52%'}}
                                />
                            </div>
                        </Col>
                        <Col style={inputFieldsColStyle}>
                            <Input 
                                type="text" 
                                name="phone" 
                                id="phone" 
                                placeholder={i18n.t('screens:orderHistoryScreen.customerPhone')} 
                                value={phone} 
                                onChange={this.changeState} 
                                style={inputFieldsStyle} 
                            />
                        </Col>
                        <Col style={inputFieldsColStyle}>
                            <Input 
                                type="text" 
                                name="email" 
                                id="email" 
                                placeholder={i18n.t('screens:orderHistoryScreen.customerEmail')} 
                                value={email} 
                                onChange={this.changeState} 
                                style={inputFieldsStyle} 
                            />
                        </Col>
                        {this.renderCustomersStatusDropdown()}
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '30px' }}>
                            <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}>{i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        )
    }

    renderSearchCustomers() {
        const { headerStyle } = styles;
        const { id } = this.props.match.params;

        return (
            <Row xs={12} style={{margin: '20px 0px 0px', paddingBottom: '30px'}}>
                <Col xs={12}>
                    <div style={headerStyle}>
                            <MaterialIcon icon="text_snippet" size={20} color='#0288d1' />
                            <span style={{marginLeft: '3px'}}>{i18n.t('screens:customersScreen.customersData')}</span>
                    </div>
                </Col>
                <Col xs={3} style={{paddingRight: '0px'}}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label xs={4}>{i18n.t('screens:customersScreen.startDate')}</Label>
                        <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                            <Input 
                                id="startDate"
                                type="date" 
                                name="startDate"
                                onChange={this.changeState}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={3} style={{paddingLeft: '0px'}}>
                    <FormGroup xs={12} style={{ display: 'flex', width: '100%', marginBottom: '0px', alignItems: 'center'}}>
                        <Label xs={4}>{i18n.t('screens:customersScreen.endDate')}</Label>
                        <Col xs={6} style={{display: 'flex', paddingLeft: '0px'}}>
                            <Input 
                                id="endDate"
                                type="date" 
                                name="endDate"
                                onChange={this.changeState}
                            />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={2}>
                    <Button disabled={!this.state.startDate || !this.state.endDate} onClick={() => this.downloadCustomers(id)} color="primary" style={{ display: 'flex', alignItems: 'center'}} >
                        <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="cloud_download" color="#fff" size={18} /></span>
                        <span style={{marginLeft: '3px'}}>{i18n.t('common:buttons.download')}</span>
                    </Button>
                </Col>
            </Row>
        )
    }

    searchCustomersByStatus() {
        const { headerStyle } = styles;
        const { customersInsightsDisabled } = this.props.customersInfo;
        
        return (
            <Row xs={12}>
                <Col xs={12} style={{marginTop: '15px', paddingLeft: '30px'}}>
                    <div style={customersInsightsDisabled ? {...headerStyle, marginBottom: '0px'} : headerStyle}>
                        <MaterialIcon icon="perm_identity" size={20} color='#0288d1' />
                        <span style={{marginLeft: '3px'}}>{i18n.t('screens:customersScreen.customersByStatus')}</span>
                    </div>
                </Col>
                {
                    !customersInsightsDisabled ? 
                        <Fragment>
                            <Col xs={12}>
                                {this.renderSearchFields()}
                            </Col>
                            <Col xs={12} style={{marginTop: '15px'}}>
                                {this.renderCustomerInfoTable()}
                            </Col> 
                        </Fragment> : 
                        <Col xs={12} >
                            <CommonMessage message={i18n.t('screens:customersScreen.customersByStatusDisabled')} />
                        </Col>
                }
            </Row>
        )
    }

    render() {
        const { currentlyLoggedInUser } = this.props;

        return(
            <Fragment>
                {currentlyLoggedInUser.role === MENUU_MASTER_ADMIN ? this.renderSearchCustomers() : null}
                {this.searchCustomersByStatus()}
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        restaurant: state.restaurant,
        customersInfo: state.customersInfo,
        currentlyLoggedInUser: state.user
    }
};

export default connect(mapStateToProps, {
    downloadCustomersData, getCustomersInfo
})(CustomersContainer);

let styles = {
    headerStyle: {
        paddingLeft: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        marginBottom: '30px',
        color: '#0088d1',
        width: '250px'
    },
    inputFieldsColStyle: {
        maxWidth: '250px'
    },
    inputFieldsStyle: {
        width: '240px'
    },
    headerContainer: {
        width: '100%',
        height: '45px',
        margin: '0px',
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'center',
        alignItems: 'center',
        backgroundColor: '#F8F8F8'
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    },
    selectOrderStyle: {
        color: '#0087d7',
        cursor: 'pointer'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customers/CustomersContainer.js